import styled from "styled-components";

// Default white background with a small box shadow.
export const Shadow = styled.div`
    background: ${(props) => props.theme.color.lightest};
    border-radius: 4px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
`;
